import {
  __name
} from "./chunk-DVUTYNGK.jsx";

// src/utils/css/css.ts
import { cx, css } from "@headout/pixie/css";
var pxToRem = /* @__PURE__ */ __name((px, base = 16) => {
  return 1 / base * px;
}, "pxToRem");
var applyStylesOverride = /* @__PURE__ */ __name((styles, overrideStyles) => {
  const overrides = css(overrideStyles != null ? overrideStyles : {});
  return cx(styles, overrides);
}, "applyStylesOverride");

export {
  pxToRem,
  applyStylesOverride
};
